import 'jquery-ui';
import 'infinite-scroll';

import './base/';
import './sliders';
import './popups';
import './product';
import './recently-view';
import './register';
import './cart';

import { mailchimp } from './mailchimp';
import { accordion } from './accordion';

const $win = $(window);
const $doc = $(document);
const $header = $('.header');
const mobileWidth = 768;

accordion('.accordion h6', true);

mailchimp('.subscribe form, .subscribe-popup form');

$('.datepicker').datepicker();

let barHeight = $('.bar--notification').length
  ? $('.bar--notification').outerHeight()
  : 0;
$('.wrapper').css('padding-top', barHeight + 'px');

$win.on('resize', function() {
  if (
    $('.bar--notification').length &&
    barHeight !== $('.bar--notification').outerHeight()
  ) {
    barHeight = $('.bar--notification').outerHeight();
    $('.wrapper').css('padding-top', barHeight);
  }
});

$doc
  .on('click', '.nav-trigger', function(e) {
    e.preventDefault();

    $('.nav-mobile').slideToggle(200);
  })
  .on('click', '.nav-mobile > ul > .menu__item--has-dropdown', function(e) {
    const $this = $(this);
    const $siblings = $this.siblings();

    if (!$this.hasClass('active')) {
      $this
        .addClass('active')
        .children('.menu__dropdown')
        .slideDown();

      $siblings
        .removeClass('active')
        .children('.menu__dropdown')
        .slideUp();

      $this.children('a').addClass('clicked');

      $siblings.find('.clicked').removeClass('clicked');
    } else {
      $this
        .removeClass('active')
        .children('.menu__dropdown')
        .slideUp();

      $this.find('.clicked').removeClass('clicked');
    }
  })

  .on('click', '.nav-mobile > ul > .menu__item--has-dropdown > a', function(e) {
    const $this = $(this);

    if (!$this.hasClass('clicked')) {
      e.preventDefault();
      $this.addClass('clicked');
    }
  })
  .on('click', '.search-bar', function(e) {
    const $this = $(this);

    if (!$this.hasClass('active')) {
      e.preventDefault();

      $this.addClass('active');
    }
  })
  .on('click', function(event) {
    if ($win.width() >= mobileWidth) {
      let $trigger = $('.search-bar');
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $('.search-bar').removeClass('active');
      }
    }
  })
  .on(
    'mouseover',
    '.nav .menu__dropdown--alternative a[data-image]',
    function() {
      if (
        $(this)
          .data('image')
          .indexOf('no-image') === -1
      ) {
        $('.nav .nav__image img').attr('src', $(this).data('image'));
      } else {
        $('.nav .nav__image img').attr('src', '');
      }
    }
  )
  
